import React from 'react';
import { Divider, Icon } from 'antd';

export default function AddNewEmailType({ onClick }) {
  return (
    <Divider dashed style={{ margin: '16px 0 0 0' }}>
      <div
        className="flex items-center"
        style={{ cursor: 'pointer' }}
        onClick={onClick}
      >
        <Icon type="plus-circle" />
        <p style={{ fontSize: 12, marginBottom: -2, marginLeft: 5 }}>
          Add New Email Type
        </p>
      </div>
    </Divider>
  );
}
